
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { selectHavainnotState } from "../selectors";
import { IAppMessage } from "../reducers/messageReducer";

// SELECTORS
const selectMessageState = createSelector(
    selectHavainnotState,
    (workPermit) => workPermit.message
);


export const selectMessagesByIdState = createSelector(
    selectMessageState,
    (state) => state.messages,
);

export const selectMessageList = createSelector(
    selectMessageState,
    (state) => state.messageList,
);


const createSelectMessageById = (messageId: string) => (
    createSelector(
        selectMessagesByIdState,
        (messages) => messages[messageId]
    )
);



// HOOKS
export const useMessageById = (messageId: string): IAppMessage | undefined => useSelector(createSelectMessageById(messageId));

